import { create } from 'zustand';
import { FileTypes } from '../types/file';

type TLoginStore = {
  fileTypes: FileTypes,
  setFileTypes(files: TLoginStore['fileTypes']): void,
};
const useFilesStore = create<TLoginStore>(set => ({
  fileTypes: [
    { name: 'app', sourceType: 10, count: 0 },
    { name: 'note', sourceType: 20, count: 0 },
    { name: 'call', sourceType: 30, count: 0 },
  ],
  setFileTypes: (fileTypes: TLoginStore['fileTypes']) => set(_state => ({ fileTypes })),
}));

export default useFilesStore;
